const OrderLangs = {
  orderProcessing: {
    title: "Đơn hàng đang thực hiện",
    detail: "Chi tiết đơn hàng {{orderId}}",
    update: "Cập nhật đơn hàng {{orderId}}",
    totalDebit: "{{money}} VNĐ",
    designed: "Đã thiết kế (Chờ in)",
    waitingPrint: "Đang in",
    printed: "Đã in",
    cancel: "Đã hủy",
    draft: "Nháp",
    sale: "Đã chốt sale",
    needConfirm: "Chờ xác nhận",
    copy: "Sao chép đơn hàng {{orderId}}",
  },
  filterBy: "Tìm theo",
  searchBy: "Tìm kiếm",
  searchByPlaceHolder: "Tìm kiếm đơn hàng",
  createdDate: "Ngày tạo",
  updatedDate: "Ngày cập nhật",
  name: "đơn",
  delete: "Xoá",
  filterGroup: {
    all: "Tất cả",
    customerName: "Tên khách hàng",
    companyName: "Tên công ty",
    orderNo: "Mã đơn hàng",
    orderFile: "Tên file",
  },
  orderDetail: {
    customer: {
      title: "Thông tin khách hàng",
      name: "Tên khách hàng:",
      email: "Email:",
      phone: "Số điện thoại:",
      company: "Tên công ty:",
    },
    delivery: {
      title: "Thông tin giao hàng",
      name: "Tên người nhận:",
      phone: "Số điện thoại:",
      address: "Địa chỉ:",
      receiveDay: "Ngày nhận hàng:",
      deliveryDay: "Ngày giao hàng:",
    },
    info: {
      title: "Thông tin đơn hàng:",
      name: "Tên đơn hàng:",
      category: "Loại hàng:",
      paper: "Loại giấy:",
      printType: "Kiểu in:",
      method: "Kích thước TP: (mm)",
      numPrintFace: "Cán màng:",
      outsource: "Gia công khác:",
      notePrint: "Ghi chú sản xuất:",
    },
    price: {
      title: "Giá trị đơn hàng",
      template: "Số lượng mẫu:",
      quantity: "Số lượng in:",
      unitPrice: "Đơn giá:",
      designFee: "Phí thiết kế:",
      shippingFee: "Phí ship:",
      deposite: "Tạm ứng:",
      amount: "Thành tiền:",
      finalAmount: "Còn lại phải thanh toán:",
    },
    outsource: {
      title: "Gia công sau in",
    },
    employee: {
      title: "Thông tin phụ trách đơn hàng",
      creator: "Người tạo đơn:",
      handler: "Người xử lý:",
      warehouseStaff: "Người lưu kho:",
      noHandler: "Chưa có",
      dateCreatePO: "Ngày tạo đơn:",
      dateHandlerPO: "Ngày xử lý:",
      dateStorePO: "Ngày lưu kho:",
    },
    billInfo: {
      title: "Thông tin thanh toán",
      template: "SL Mẫu:",
      quantity: "SL in:",
      unitPrice: `Đơn giá\n(vnđ):`,
      designFee: "Phí TK:",
      shippingFee: "Phí VC:",
      amount: "Thành tiền:",
      otherFee: "Phí khác:",
      vatFee: "VAT:",
      deposite: "Tạm ứng:",
      remainingAmount: `Còn lại phải thu:`,
    },
  },
  orderUpdate: {
    error: {
      notes: "Vui lòng nhập ghi chú",
      paymentMethod: "Vui lòng chọn phương thức thanh toán",
      whoCollectionMoney: "Vui lòng nhập tên người thu tiền",
      number: "Chỉ được nhập số",
      orderProcessing: "Cập nhật đơn hàng thất bại",
      paymentType: "Vui lòng chọn phương thức thu tiền",
      dateCollectMoney: "Vui lòng chọn ngày thu tiền",
      companyDebit: "Vui lòng nhập số tiền công ty bù",
      moneySource: "Vui lòng chọn nguồn thu",
    },
    success: {
      orderProcessing: "Cập nhật đơn hàng thành công",
    },
    form: {
      paymentMethod: "Phương thức thanh toán",
      amount: "Tổng tiền",
      deposite: "Tạm ứng",
      note: "Ghi chú",
      cod: "Còn lại phải thu",
      cash: "Nhập số tiền thu",
      casheNumber: "Số tiền đã thu",
      dayCollectMoney: "Ngày thu",
      moneySource: "Nguồn thu",
      whoCollectionMoney: "Người thu tiền",
      companyDebit: "Công ty bù số tiền thiếu",
      otherFee: "Chi phí khác",
      vatFee: "% VAT",
      vatFeeNumber: "Phí VAT",
      discount: "Giảm giá",
    },
    save: "Cập nhật",
  },
  orderNeedCollect: {
    title: "Đơn hàng cần thanh toán",
    totalMoneyReceive: "Tổng tiền phải thu: ",
    filterCustomer: "Lọc khách hàng",
    pay: "Thanh toán",
    debit: "Công nợ",
    emailDebit: "Gửi email công nợ",
    error: {
      notSupportMultiCustomer: "Chưa hổ trợ nhiều khách hàng",
      printFail: "In thất bại",
      sendEmailFail: "Gửi email thất bại",
    },
    success: {
      sendEmail: "Gửi email thành công",
    },
  },
  orderNeedCheck: {
    title: "Đơn hàng cần kiểm tra",
  },
  orderNeedConfirm: {
    title: "Đơn hàng cần xác nhận",
    tabCash: "Tiền mặt",
    tabPerson: "Cá nhân",
    tabCompany: "Công ty",
    tabOthers: "Khác",
  },
  orderStore: {
    title: "Đơn hàng lưu kho",
    tabStored: "Lưu kho",
    tabDelivery: "Đang giao hàng",
    btnBillDelivery: "Biên bản GH",
    btnBillDelivery2: "Biên bản GH V2",
    confirmDelivery: "Xác nhận giao hàng",
    loadingCustomer: "Đang tải thêm khách hàng",
    noCustomer: "Không còn khách hàng",
    deliverProvider: "Đối tác giao hàng",
    noteDeliver: "Ghi chú giao hàng",
    noteCancel: "Lí do hủy",
    others: "Khác",
    companyStaff: "Nhân viên công ty",
    ortherDeliver: "Tên người giao hàng",
    errorOrtherDeliver: "Nhập tên người giao hàng",
    trackingId: "Mã vận chuyển (nếu có)",
    messageDeliverSuccess: "Cập nhật đơn hàng thành công",
    done: "Đã giao",
    cancelDelivery: "Huỷ giao",
    messageDone: "{{name}} đã giao hàng thành công",
    cancel: "Huỷ đơn",
    btnRetailBill: "Hoá đơn bán hàng"
  },
  orderSearch: {
    title: "Tên đơn hàng",
    orderNo: "Mã đơn hàng",
    method: "Kích thước",
    file: "Tên file",
    paper: "Loại giấy",
  },
  orderWaitingPrintList: {
    title: "Danh sách chờ in",
    card: "Card",
    toroi: "Tờ rơi",
    sticker: "Sticker",
    other: "Khác",
    success: {
      assign: "Nhận đơn thành công",
    },
    error: {
      assign: "Nhận đơn thất bại",
    },
    group: {
      btnMultiOrder: "1 bài nhiều đơn",
      btnMultiGroup: "1 đơn nhiều bài",
      btnOnlyOrder: "1 bài 1 đơn",
      title: "Tạo bình bài",
    },
  },
  orderPrintingList: {
    title: "Danh sách đang in",
    outsourceDate: "Ngày gửi qua gia công",
    done: "Hoàn thành",
    noteReject: "Lí do từ chối",
    success: {
      reject: "Từ chối thành công",
      done: "Xác nhận hoàn thành",
    },
    error: {
      reject: "Từ chối thất bại",
      done: "Hoàn thành thất bại",
    },
    btnDoneGroup: "Hoàn thành bình bài",
    btnUpdateGroup: "Cập nhật bài",
  },
  orderPrinted: {
    title: "Danh sách đã in",
    store: "Lưu kho",
    success: {
      assign: "Lưu kho thành công",
    },
    error: {
      assign: "Lưu kho thất bại",
    },
  },
  orderCreate: {
    title: "Tạo đơn hàng",
    form: {
      titleCustomer: "Thông tin khách hàng",
      titleOrder: "Thông tin đơn hàng",
      titlePayment: "Thông tin thanh toán",
      titleImage: "Hình ảnh đơn hàng",
      customerName: "Tên khách hàng",
      deliveryAddress: "Địa chỉ giao hàng",
      orderType: "Loại đơn",
      orderNormal: "Đơn thiết kế",
      orderCustom: "Đơn sản xuất",
      receiverName: "Tên người nhận",
      deliveryDate: "Ngày giao hàng",
      categoryName: "Hàng hóa",
      categoryList: "Danh sách hàng hóa",
      categoryType: "Loại hàng hóa",
      printType: "Kiểu in",
      paperType: "Kiểu giấy",
      printFace: "Mặt in",
      oneFace: "Một mặt",
      twoFace: "Hai mặt",
      method: "Quy cách",
      fileName: "Tên file thiết kế",
      outsources: "Cán màng",
      templateNumber: "Số lượng mẫu",
      printNumber: "Số lượng in",
      price: "Đơn giá",
      designFee: "Phí thiết kế",
      shippingFee: "Phí vận chuyển",
      deposite: "Tạm ứng",
      vat: "Xuất VAT",
      vatNo: "Không",
      vatYes: "Có",
      paymentMethod: "Phương thức thanh toán",
      paymentCash: "Tiền mặt",
      paymentDebt: "Công nợ",
      paymentAtm: "Chuyển khoản",
      totalAmount: "Thành tiền",
      notes: "Ghi chú",
      notes_detail: "Ghi chú sản xuất",
      btnCancelOrder: "Huỷ đơn",
      btnUpdateOrder: "Cập nhật đơn",
      btnUpdateDraft: "Tiếp tục theo dõi",
      btnCreateOrder: "Chốt sale",
      btnConfirmOrder: "Phản hồi thiết kế",
    },
    error: {
      customerName: "Chọn khách hàng",
      deliveryAddress: "Nhập địa chỉ giao hàng",
      categoryList: "Chọn hàng hóa",
      categoryType: "Chọn loại hàng hóa",
      method: "Bắt buộc",
      fileName: "Nhập tên file",
      templateNumber: "Nhập số lượng mẫu",
      printNumber: "Nhập số lượng in",
      price: "Nhập đơn giá",
    },
  },
};
export default OrderLangs;
